import { FC, useContext } from "react";
import DataTable from "../../../../../shared/components/dataTable";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";
import { Industry } from "../../../../../shared/interfaces/industry";

const DesignationList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/designation", {
    params: {
      ...payload,
    },
  });
  const designationData = data as any;

  const navigateToDetails = () => {
    navigate("/master-datas/designations/create");
  };

  const designationDisplayColumns = ["name", "industry", "enabled"];
  let desigantionsList: Industry[] = [];

  desigantionsList = designationData?.items?.map((desigantion: any) => {
    return {
      id: desigantion.id,
      name: desigantion?.name,
      industry: desigantion?.industry?.name,
      enabled: desigantion?.enabled,
    };
  });

  const titleBarNode = <SearchBox />;
  const titleBar = {
    title: "Designations",
    headerTitle: "Designations",
    buttonTitle: "Create",
    titleBarNodes:
      (designationData?.totalItems || payload.search) && titleBarNode,
    onClick: navigateToDetails,
    disabled: designationData?.entityPermissions
      ? !designationData?.entityPermissions?.includes("Designation-Create")
      : false,
    subHeading: "",
    rowCount: designationData?.totalItems,
  };

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Designation"
          data={desigantionsList}
          displayColumns={designationDisplayColumns}
          linkColumn="name"
          linkUrl="/master-datas/designations"
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={designationData?.totalItems}
          deleteApiUrl="/designation"
          refetchFunction={fetchData}
          disabled={
            designationData?.entityPermissions
              ? !designationData?.entityPermissions?.includes(
                  "Designation-Delete"
                )
              : false
          }
        />
      )}
    </TableViewContainer>
  );
};

export default DesignationList;
